import { Box, TextField, Typography } from '@mui/material';
import EditableNumberCell from 'components/table/EditableNumberCell';
import { useAppSelector } from 'core/hooks/hooks';
import { sumWithCurrency } from 'core/services/currency.service';
import { budgetMonthSelector } from 'core/store/selectors/monthBudget.selector';
import { periodSelector } from 'core/store/selectors/period.selector';
import { useContext } from 'react';
import { BudgetMonthContext } from './BudgetMonthContextProvider';

const PrevMonthResidue = () => {
  const budgetMonth = useAppSelector(periodSelector);
  const { prevPeriodResidue } = useAppSelector(
    budgetMonthSelector(budgetMonth)
  );
  const { prevPeriodResidueState, isEditing, onPrevPeriodResidueChange } =
    useContext(BudgetMonthContext);

  return (
    <Box
      sx={{
        mb: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#f5f5f5',
        mx: -1,
        px: 1,
        py: 0.5,
        borderRadius: 1
      }}
    >
      <Typography sx={{ fontSize: 11 }}>Previous month residue:</Typography>
      {isEditing ? (
        <TextField
          sx={{ width: '80px' }}
          type="number"
          variant="standard"
          value={prevPeriodResidueState}
          onChange={e =>
            onPrevPeriodResidueChange(
              e.target.value ? Number(e.target.value) : undefined
            )
          }
        />
      ) : (
        <EditableNumberCell
          initialValue={prevPeriodResidue ?? 0}
          onSaveValue={() => {}}
          renderValue={value => <>{sumWithCurrency(value)}</>}
        />
      )}
    </Box>
  );
};

export default PrevMonthResidue;
